<template>
    <div class="c-rkw-content-slider" v-if="instances.length" v-touch:swipe.left="toNext" v-touch:swipe.right="toPrev">
        <hr class="c-rkw-content__line">
        <div class="o-grid">
            <div class="o-grid__col u-12/12">
                <h4 class="c-rkw-content__header2">Weitere Beispiele aus {{model.title}}</h4>
            </div>
        </div>
        <div class="o-grid">
            <div class="o-grid__col u-1/12">
                <span class="c-rkw-content-slider__prev-item" v-if="hasPrev()" @click.prevent="toPrev"></span>
            </div>
            <div class="o-grid__col u-10/12">

                    <transition-group name="c-rkw-content-slider__slide" tag="div" class="o-grid c-rkw-content-slider__container" v-on:before-enter="beforeEnter" v-on:after-leave="afterLeave">
                        <div class="o-grid__col u-4/12 u-4/4@mobile" v-for="(instance, instanceIndex) in instances" v-bind:key="instance" v-if="instanceIndex >= minCount && instanceIndex < maxCount">
                            <div class="c-rkw-bookmark-modal__bookmark c-rkw-content-slider__item" :style="`background-image: url(${settings.pageUrl}${getBookmarkContent(instance).sliderImages[0][1]});`" @click.prevent="setActive(instance)">
                                <span class="c-rkw-bookmark-modal__bookmark-text c-rkw-content-slider__text">
                                    <strong>{{getBookmarkContent(instance).content.header}}</strong><br><br>
                                    {{getBookmarkContent(instance).content.subheader}}
                                </span>
                            </div>
                        </div>
                    </transition-group>
            </div>
            <div class="o-grid__col u-1/12">
                <span class="c-rkw-content-slider__next-item" v-if="hasNext()" @click.prevent="toNext"></span>
            </div>

        </div>
    </div>
</template>

<script>
    import mixins from "../mixins"

    export default {
        data () {
            return {
                count: 0,
                onSlide: false
            }
        },
        mixins: [mixins],
        computed: {
            settings () {
                return this.$store.state.settings
            },
            minCount () {
                return this.count
            },
            maxCount () {
                let i = 3
                if(this.isMobile()) {
                    i = 1
                }
                return this.count + i
            }
        },
        watch: {
            'activeInstance' () {
                this.count = 0
            }
        },
        methods: {
            setActive (instanceId) {
                this.$store.commit('setActiveInstance', instanceId)
                router.push({path: '/beispiel/' + this.getInstanceURI(instanceId)})
                document.getElementsByClassName('c-rkw-modal__wrapper')[0].scrollTop = 0
            },
            hasPrev () {
                return (this.count > 0)
            },
            hasNext() {
                return this.maxCount < this.instances.length
            },
            toPrev() {
                console.log('PREV', this)
                if(this.hasPrev() && this.onSlide === false) {
                    this.count--
                }
            },
            toNext() {
                console.log(this.onSlide)
                console.log(this.count)
                if(this.hasNext() && this.onSlide === false) {
                    this.count++
                }
            },
            beforeEnter () {
                this.onSlide = true
            },
            afterLeave () {
                this.onSlide = false
            }
        },
        props: {
            // this allows using the `value` prop for a different purpose
            instances: {
                type: Array
            },
            model: {
                type: Object
            },
            activeInstance: {
                type: Number
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ContentSlider.vue?bf1870ac